import { render, staticRenderFns } from "./PwaInstallPrompt.vue?vue&type=template&id=22febeaf&scoped=true"
import script from "./PwaInstallPrompt.vue?vue&type=script&lang=ts"
export * from "./PwaInstallPrompt.vue?vue&type=script&lang=ts"
import style0 from "./PwaInstallPrompt.vue?vue&type=style&index=0&id=22febeaf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22febeaf",
  null
  
)

export default component.exports